
// const sty ={ width:'300px', height:'100px',fontSize:'16px',paddingTop:'10px'}
// export const sourceOptions = [
  
//   { key: 'findprop.in', value: 'findprop.in',  text: 'findprop.in',style: sty },
//   { key: '99acres.com', value: '99acres.com',  text: '99acres.com', style: sty},
//   { key: 'magicbricks.com', value: 'magicbricks.com',  text: 'magicbricks.com',style: sty },
//   { key: 'housing.com', value: 'housing.com',  text: 'housing.com',style: sty },
//   { key: 'justdial.com', value: 'justdial.com',  text: 'justdial.com',style: sty },
//   { key: 'others', value: 'others',  text: 'others',style: sty }
// ]

import { scrollFunction } from "../functions/Functions";

//********** */
export const sourceO = [
  '',
  'findprop.in',
  '99acres.com',
  'magicbricks.com',
  'housing.com',
  'justdial.com',
  'others'
];
export const source = () => {
  return sourceO.map(value => ({ key: value, text: value, value: value,style:{fontSize:'18px'} }));
};

export const data1=[
    // {link:"#home",name:'Home'},
    {link:"#about",name:'About Us',fn:()=>scrollFunction('about'),},
    {link:"#service",name:'Services',fn:()=>scrollFunction('service')},
    {link:"#why",name:'Why Choose Us',fn:()=>scrollFunction('why')},
    {link:"#review",name:'Reviews',fn:()=>scrollFunction('review')},
    {link:"#award",name:'Awards',fn:()=>scrollFunction('award')},    
    ]
    export const data2=[
        // {link:"#main-footer",name:'Contact Us'},
    ]

    export const data = [...data1, ...data2]
